import { Fragment, ReactNode } from "react";

export interface PageBlock<TModel> {
    key: string;
    order: number;
    isVisible?: (model: TModel) => boolean;
    render: () => ReactNode;
}

interface BlockListProps<TModel> {
    blocks: PageBlock<TModel>[];
    model: TModel;
}

function resolveVisibleBlocks<TModel>(
    blocks: PageBlock<TModel>[],
    model: TModel,
): PageBlock<TModel>[] {
    return blocks
        .filter((block) => block.isVisible?.(model) ?? true)
        .sort((left, right) => left.order - right.order);
}

export function BlockList<TModel>({ blocks, model }: BlockListProps<TModel>) {
    const visibleBlocks = resolveVisibleBlocks(blocks, model);

    return (
        <>
            {visibleBlocks.map((block) => (
                <Fragment key={block.key}>{block.render()}</Fragment>
            ))}
        </>
    );
}
